export default __webpack_public_path__ + "static/media/masterclass.eebc3d27.jpg";